import { render, staticRenderFns } from "./login-configuration.vue?vue&type=template&id=6c461969&scoped=true&"
import script from "./login-configuration.vue?vue&type=script&lang=js&"
export * from "./login-configuration.vue?vue&type=script&lang=js&"
import style0 from "./login-configuration.vue?vue&type=style&index=0&id=6c461969&scoped=true&lang=less&rel=stylesheet%2Fless&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c461969",
  null
  
)

export default component.exports